import './pdr-dashboard.less'
import { PdrDashboardElement } from './PdrDashboardElement'
import { PdrDashboardGadgetElement } from './PdrDashboardGadgetElement'

customElements.define('pdr-dashboard', PdrDashboardElement)
customElements.define('pdr-dashboard-gadget', PdrDashboardGadgetElement)
